import { createActionTypes } from "@helpers/redux-helpers";

export const getSuggestedLivestreamsActionTypes = createActionTypes(
  "livestreams/suggested/list/get",
);

export const getSuggestedLivestreamsPortionActionTypes = createActionTypes(
  "livestreams/suggested/list/portion/get",
);
